export enum OlarkCmd {
  EXPAND_CHATBOX = 'api.box.expand',
  SEND_MESSAGE_TO_VISITOR = 'api.chat.sendMessageToVisitor'
}

export type Olark = (cmd: OlarkCmd, options?: Record<string, any>) => void;

